import { ENDPOINTS, METHODS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

const productsBaseEndpoint = ENDPOINTS.PRODUCT;
const sidesBaseEndpoint = ENDPOINTS.SIDES;

// Category API
export const productApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["products"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getProducts: builder.query({
        query: ({
          page = 1,
          per_page = 10,
          search = "",
          category_id = "",
        } = {}) => ({
          url: `${productsBaseEndpoint}`,
          params: {
            page,
            per_page,
            ...(search && { search }),
            ...(category_id && { category_id }),
          },
        }),
        transformResponse: (response) => response.data || response,
        providesTags: () => [{ type: "products" }],
        keepUnusedDataFor: 0,
      }),

      getProductsByCatId: builder.query({
        query: (categoryId) =>
          `${productsBaseEndpoint}?category_id=${categoryId}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "products" }],
        keepUnusedDataFor: 0,
      }),

      getProductById: builder.query({
        query: (productId) => `${productsBaseEndpoint}/${productId}`,
        transformResponse: (response) => response.data,
        providesTags: (result, error, productId) => [
          { type: "products", id: productId },
        ],
        keepUnusedDataFor: 0,
      }),
      getAllProduct: builder.query({
        query: () => `${productsBaseEndpoint}/product-dropdown`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "products" }],
        keepUnusedDataFor: 0,
      }),

      addProduct: builder.mutation({
        query: (requestData) => ({
          url: `${productsBaseEndpoint}`,
          method: METHODS.POST,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "products" }],
      }),
      updateProduct: builder.mutation({
        query: ({ id, requestData }) => ({
          url: `${productsBaseEndpoint}/${id}`,
          method: METHODS.PUT,
          body: requestData,
        }),
        invalidatesTags: () => [{ type: "products" }],
      }),
      deleteProduct: builder.mutation({
        query: (id) => ({
          url: `${productsBaseEndpoint}/${id}`,
          method: METHODS.DELETE,
        }),
        invalidatesTags: () => [{ type: "products" }],
      }),
      getSides: builder.query({
        query: (payload) => `${productsBaseEndpoint}/${sidesBaseEndpoint}`,
        transformResponse: (response) => response.data,
        providesTags: () => [{ type: "products" }],
        keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      getPackagingOptions: builder.query({
        query: () => `/products/cart-products`, // Your new endpoint
        transformResponse: (response) => response.data,
        providesTags: ["products"],
      }),
    }),
  });

// Export hooks for usage in components

export const {
  useGetProductsQuery,
  useGetProductsByCatIdQuery,
  useGetProductByIdQuery,
  useLazyGetProductByIdQuery,
  useAddProductMutation,
  useUpdateProductMutation,
  useGetAllProductQuery,
  useDeleteProductMutation,
  useGetSidesQuery,
  useGetPackagingOptionsQuery,
} = productApi;
